// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:34.897Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:view/login_dialog': []
})(this, function (m_module, $) {

var M = m_module.M;

M = M || {};

/**
 * Check against the server if the user is logged in
 * then invoke a specified callback.
 *
 * @param onLoginStateReady {Function}
 *        Method to invoke when the server request completes.
 *
 * TODO: Eventually, this code should be ported to M.Model.User once more CU3
 * logic has been refactored out of /src/js/cu3 and into /view and /model.
 *
 */
M.checkLoginStatus = function(onLoginStateReady) {
  $.ajax( {
    url: '/personalize/checklogin',
    type: 'POST',
    success: function(data) {
      var isLoggedIn = parseInt(data);
      onLoginStateReady(isLoggedIn);
    },
    error: function(request) {
      var requestAborted = !request.getAllResponseHeaders();
      if (!requestAborted) {
        alert('We encountered a technical issue.');
      }
    }
  });
};


/**
 * Show the login dialog to a user who is not logged in, and deal with
 * forgot password and create account options.
 *
 * @param {Function} successCallback The function to call on login, or account
 * create success.
 */
M.showLoginDialog = function(successCallback) {
  var loginDialog = new M.View.LoginDialog();

  loginDialog.bind(M.View.LoginDialog.EVENT_SHOW_SAVE_DIALOG, successCallback);

  loginDialog.render();
};

return {
};

});
